module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_18_G.117c71b8.mp3";